import styled, { keyframes } from 'styled-components';

const LoaderAnimation = keyframes`
  0% {
    box-shadow: -45px -6px, -15px 6px, 15px -6px;
  }
  33% {
    box-shadow: -45px 6px, -15px -6px, 15px 6px;
  }
  66% {
    box-shadow: -45px -6px, -15px 6px, 15px -6px;
  }
  100% {
    box-shadow: -45px 6px, -15px -6px, 15px 6px;
  }
`;

export const LoaderSpan = styled.span`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: block;
  position: relative;
  color: #C4C4C4;
  box-sizing: border-box;
  left: 15px;
  animation: ${LoaderAnimation} 1s linear infinite alternate;
`;
LoaderSpan.displayName = 'LoaderSpan';

export const LoaderContainer = styled.span`
  position: absolute;
  top: 1vh;
  bottom: 1vh;
  left: 1vw;
  right: 1vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;
LoaderContainer.displayName = 'LoaderContainer';
